import { FC, useEffect, useState, useRef } from 'react';
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { FormProvider, useForm, useFormContext } from "react-hook-form";
// import { Box, Typography, TextField, CardContent, Grid, Stack, Drawer, CircularProgress, Tooltip, SelectChangeEvent, Button, Paper, IconButton, Badge, Chip, Radio } from '@mui/material';
import { Typography,CardContent, CircularProgress, Grid, Stack, SelectChangeEvent, Autocomplete, Chip, Box, Button, Checkbox, Divider, FormControlLabel, FormGroup, IconButton, InputAdornment, MenuItem, Modal, Radio, Select, TextField, Tooltip, Alert } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import SettingsIcon from '@mui/icons-material/Settings';
import SearchIcon from '@mui/icons-material/Search';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
// import CustomTextField from "../FormFields/CustomTextField";
// import CustomThemeTextField from "../FormFields/CustomThemeTextField";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import moment from 'moment';

import { RadioProps } from '@mui/material/Radio';
import { styled } from '@mui/material/styles';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import HighlightOffTwoToneIcon from '@mui/icons-material/HighlightOffTwoTone';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { makeStyles } from "@material-ui/core/styles";
import NavigateBeforeOutlinedIcon from '@mui/icons-material/NavigateBeforeOutlined';
import FileUploader from "../Invoice/FileUploader";
import BarcodeDisplay from './BarcodeDisplay';


// app utils

import { StyledCard } from '../AccountBasicInfo/AccountBacisInfo.styles';
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import CustomSelect, { IOptions } from "../FormFields/CustomSelect";
import { StyledBoxLoader } from '../Invoice/Invoice.style';
import { Utils } from "../../utils/common-utils";
import { ApiStatus } from "../../utils/api.types";

// app imports
import { Inventory, InventoryFormInputs, InventoryNewFormInputs, IPurchaseDetails } from '../../utils/inventory.types';
import { addInventory, fetchInventoryById, updateInventory, fetchItemCategories, fetchItemSubCategories, fetchMeasuringUnits, fetchInventoryByAccountId, fetchItemSubCategoriesByCategory } from '../../store/inventoryStore/inventoryThunk';
import CategoryModal from './CategoryModal';
import { fetchGstOptions } from '../../store/gstStore/gstThunk';
import LoadingButton from '@mui/lab/LoadingButton/LoadingButton';
import { Height } from '@mui/icons-material';
import { Direction } from 'react-toastify/dist/utils';
import { InfoIcon } from 'lucide-react';


const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  transition: '0ms',
  width: 1000,
  borderRadius: 2,
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
};

const useStyles = makeStyles({
  paper: {
    border: "1.5px solid #e9ecf1",
    width: '108%',
    boxShadow: 'none',
    marginLeft: '-6px',
    borderRadius: 7
  }
});
const BpIcon = styled('span')(({ theme }) => ({
  borderRadius: '50%',
  width: 16,
  height: 16,
  boxShadow:
    theme.palette.mode === 'dark'
      ? '0 0 0 1px rgb(16 22 26 / 40%)'
      : 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
  backgroundColor: theme.palette.mode === 'dark' ? '#394b59' : '#f5f8fa',
  backgroundImage:
    theme.palette.mode === 'dark'
      ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))'
      : 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
  '.Mui-focusVisible &': {
    outline: '2px auto rgba(19,124,189,.6)',
    outlineOffset: 2,
  },
  'input:hover ~ &': {
    backgroundColor: theme.palette.mode === 'dark' ? '#30404d' : '#ebf1f5',
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    background:
      theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 'rgba(206,217,224,.5)',
  },
}));

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: '#137cbd',
  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
      content: '""',
  },
  'input:hover ~ &': {
      backgroundColor: '#106ba3',
  },
});

// Inspired by blueprintjs
function BpRadio(props: RadioProps) {
  return (
      <Radio
      disableRipple
      color="default"
      checkedIcon={<BpCheckedIcon />}
      icon={<BpIcon />}
      {...props}
      />
  );
}

// Schema to validate inventory form.
const schema = yup.object().shape({
  name: yup.string().required("Item Name is required")
});

interface InventoryProps {
  type?: string;
  model?: boolean;
  onClose?: () => void;
}

interface InventoryNewFormTest {
  name: string;
  description?: string;
}

// Estimate component. 
const InventoryFormNew: FC<InventoryProps> = ({ type, model, onClose }) => {
  const { pathname } = useLocation();
  const { inventoryId } = useParams();
  const isEditing = inventoryId ? true : false;

  // use form
  const methods = useForm<InventoryNewFormInputs>({
    resolver: yupResolver(schema),
  });
  // use form Test
  const methods2 = useForm<InventoryNewFormTest>({
    resolver: yupResolver(schema),
  });

  const classes = useStyles();
  const [wholesale, setWholesale] = useState(false);
  const [lowStock, setLowStock] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(1);
  const [itemType1, setItemType1] = useState(1);
  const [images, setImages] = useState<File[]>([]);

  // States
  const { inventories, status } = useAppSelector(state => state.inventories);
  const inventoryDetails = useAppSelector(state => state.inventories.inventoryDeatils);
  const { selectedAccount } = useAppSelector(state => state.auth);
  const { subCategories } = useAppSelector(state => state.inventories);

  // form data states
  const formRef = useRef<any>();
  const [isLoading, setIsLoading] = useState(false);
  const [isformLoaded, setIsFormLoaded] = useState(false);
  const [newInventoryId, setNewInventoryId] = useState('');
  // const [inventoryDetails, setInventoryDetails] = useState<Inventory>();
  const [open, setOpen] = useState<Array<boolean>>([false, false, false, false]);
  const [stockAsOfDate, setStockAsOfDate] = useState<Date>(new Date());
  const [state, setSate] = useState('true');
  const [taxRateOptions, setTaxRateOptions] = useState<IOptions[]>([]);
  const [selectedTaxRateValue, setSelectedTaxRateValue] = useState("");
  const [itemCategoryOptions, setItemCategoryOptions] = useState<IOptions[]>([]);
  const [itemSubCategoryOptions, setItemSubCategoryOptions] = useState<IOptions[]>([]);
  const [measuringUnitOptions, setMeasuringUnitOptions] = useState<IOptions[]>([]);

  const [skuOptions, setSkuOptions] = useState<IOptions[]>([]);
  

  const [itemCategoryId, setItemCategoryId] = useState("");
  const [itemCategoryValue, setItemCategoryValue] = useState(null);
  const [itemSubCategoryId, setItemSubCategoryId] = useState("");
  const [itemSubCategoryValue, setItemSubCategoryValue] = useState(null);
  const [itemMeasuringUnitId, setItemMeasuringUnitId] = useState("");
  const [itemMeasuringUnitValue, setItemMeasuringUnitValue] = useState(null);
  const [itemPurchaseUnitValue, setItemPurchaseUnitValue] = useState(null);
  const [itemPurchaseUnitId, setItemPurchaseUnitId] = useState("");

  const [itemMeasuringSecondaryUnitId, setItemMeasuringSecondaryUnitId] = useState("");
  
  const [itemType, setItemType] = useState('Product');
  const [itemTypeProductChipColor, setIiemTypeProductChipColor] = useState('default');
  const [itemTypeServiceChipColor, setIiemTypeServiceChipColor] = useState('default');
  const [parentSkus, setParentSkus] = useState([]);
  const [selectedParentSkuTags, setSelectedParentSkuTags] = useState([]);

  // Category modal states
  const [categoryModalOpen, setCategoryModalOpen] = useState(false);
  const [isSubCategoryModal, setIsSubCategoryModal] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [editingSubCategory, setEditingSubCategory] = useState(null);

  const [purchaseDetails, setPurchaseDetails] = useState<IPurchaseDetails>();

  const [gst, setGst] = useState("");
  const [mrpWarning, setMrpWarning] = useState("");
  const [pendingSubCategoryId, setPendingSubCategoryId] = useState<string | null>(null);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();


  const handleListItemClick = (index: number) => {
    setSelectedIndex(index);
  };

  const handleDateChange = (newValue: Date | null, name: string | undefined) => {
    if (newValue) {
      setStockAsOfDate(newValue);
    }
  };

  const handleItemTypeClick = (e: any, name: string) => {
    console.log(name);
    console.log(e);
    const field_name = e.target.name;
    if (name) {
      setItemType(name);
      methods.setValue('itemType', name);
      // if (field_name == 'Product') {
      //   setIiemTypeProductChipColor('primary')
      //   setIiemTypeServiceChipColor('default')
      // }
      // if (field_name == 'Service') {
      //   setIiemTypeServiceChipColor('primary')
      //   setIiemTypeProductChipColor('default')
      // }
    }
  }

  const handleOpenCategoryModal = (forSubCategory = false, editCategory: any = null, editSubCategory: any = null) => {
    console.log('handleOpenCategoryModal called with:', { forSubCategory, editCategory, editSubCategory });
    setIsSubCategoryModal(forSubCategory);
    setEditingCategory(editCategory);
    setEditingSubCategory(editSubCategory);
    setCategoryModalOpen(true);
  };

  const handleCloseCategoryModal = () => {
    setCategoryModalOpen(false);
    setIsSubCategoryModal(false);
    setEditingCategory(null);
    setEditingSubCategory(null);
  };

  const refreshCategoriesData = () => {
    // Refresh categories
    setItemCategoryOptions([]);
    dispatch(fetchItemCategories()).unwrap().then(async (data) => {
      if (data) {
        if (data.length > 0) {
          const options: IOptions[] = [];
          await data.forEach(async (item: string | any) => {
            options.push({ label: item.name, value: item._id });
          });
          setItemCategoryOptions(options);
        }
      }
    });

    // Refresh subcategories if category is selected
    if (itemCategoryId) {
      dispatch(fetchItemSubCategoriesByCategory(itemCategoryId));
    }
  };

  //Method to handle invoice form submit.
  const onSubmit = async (data: InventoryNewFormInputs) => {
    console.log("onSubmit Called ======== ");
    console.log(data);
    if (data) {
      data.account = selectedAccount._id;
      data.stockAsOfDate = stockAsOfDate.toString();
      if (data.subCategory == '') delete data.subCategory;
      if (data.category == '') delete data.category;
      // if (data.baseUnit == '') delete data.baseUnit;
      // if (data.secondaryUnit == '') delete data.secondaryUnit;
      if (data.gst == '') delete data.gst;

      data.itemType = selectedIndex == 1 ? "Product" : "Service";
      data.parentSkus = (parentSkus && parentSkus.length > 0 ) ? parentSkus : [];
      // data.crossSellSkus = (crossSellSkus && crossSellSkus.length > 0 ) ? parentSkus : [];
      // data.upSellSkus = (upSellSkus && upSellSkus.length > 0 ) ? parentSkus : [];
      // data.tags = (tags && tags.length > 0 ) ? parentSkus : [];
       
    }

    console.log("final form data ===> ", data);

    try {
      if (!isEditing) {
        console.log("creating new inventory")
        await dispatch(addInventory(data)).unwrap().then(async (data) => {
          if (data) {
            console.log(data);
            navigate('/inventory');
          }
        });
      } else {
        console.log("updating existing Inventory ....")
        if (inventoryId) {
          await dispatch(updateInventory({ id: inventoryId, inventoryPayload: data })).unwrap().then( (responseData) => {
            if (responseData.message) onCancel();
          });
          setNewInventoryId(inventoryId)
        }
      }
    } catch (error: any) {
      // Empty catch block. 
    }
  };

  // Method to handle Cancel button click.
  const onCancel = () => {
    methods.reset();
    const cancelLink = `/inventory`;
    navigate(cancelLink);
  };

  // useEffect(() => {
  //   dispatch(fetchGstOptions()).unwrap().then(async (data) => {
  //     if (data) {
  //       if (data.length > 0) {
  //         await data.forEach(async (item: string | any) => {
  //           setTaxRateOptions((taxRateOptions: any) => ([...taxRateOptions, { label: item.lable, value: item._id }]));
  //         });
  //       }
  //     }
  //   });
  // }, []);

  useEffect(() => {

    let isMounted = true;
    const getItemCategories = async () => {
      let options: IOptions[] = [];
      const data: any = await dispatch(fetchItemCategories());
      if (data.payload.length > 0) {
        await data.payload.forEach(async (item: string | any) => {
          options.push({ label: item.name, value: item._id })  
        });
        if (isMounted && options.length > 0) {
          setItemCategoryOptions(options);
        }
      }
    }

    const getTaxRates = async () => {
      let options: IOptions[] = [];
      const data: any = await dispatch(fetchGstOptions());
      if (data.payload.length > 0) {
        await data.payload.forEach(async (item: string | any) => {
          options.push({ label: item.lable, value: item._id })  
        });
        if (isMounted && options.length > 0) {
          setTaxRateOptions(options);
        }
      }
    }

    const getMeasuringUnits = async () => {
      let options: IOptions[] = [];
      const data: any = await dispatch(fetchMeasuringUnits());
      if (data.payload.length > 0) {
        await data.payload.forEach(async (item: string | any) => {
          options.push({ label: `${item.name} (${item.code})`, value: item._id })  
        });
        if (isMounted && options.length > 0) {
          setMeasuringUnitOptions(options);
        }
      }
    }

    const getInventories = async () => {
      let options: IOptions[] = [];
      const data: any = await dispatch(fetchInventoryByAccountId(selectedAccount._id));
      console.log(data);
      if (data.payload.length > 0) {
        await data.payload.forEach(async (item: string | any) => {
          options.push({ label: item.name, value: item._id })  
        });
        if (isMounted && options.length > 0) {
          setSkuOptions(options);
        }
      }
    }

    getItemCategories();
    getMeasuringUnits();
    getTaxRates();
    getInventories();
    return () => {
      isMounted = false;
    };

  }, []);

  const getItemSubCategory = async (catgoryId:any) => {
    let options: IOptions[] = [];
    const data: any = await dispatch(fetchItemSubCategories(catgoryId));
    if (data.payload.length > 0) {
      await data.payload.forEach(async (item: string | any) => {
        options.push({ label: item.name, value: item._id })  
      });
      if (options.length > 0) {
        setItemSubCategoryOptions(options);
      }
    }
    return options;
  }

  useEffect(() => {
    console.log("Called useEffect after onChangeItemCategoryHandler -----");
    console.log(itemCategoryId);
    if (itemCategoryId) {
      console.log("insdie if else itemCategoryId", itemCategoryId);
      methods.setValue("subCategory", '');
      // setItemSubCategoryId('');
      dispatch(fetchItemSubCategoriesByCategory(itemCategoryId));
    }
  }, [itemCategoryId, dispatch]);

  // Sync Redux subCategories to local itemSubCategoryOptions
  useEffect(() => {
    if (subCategories && Array.isArray(subCategories)) {
      const options: IOptions[] = subCategories.map(item => ({
        label: item.name,
        value: item._id
      }));
      setItemSubCategoryOptions(options);

      // If there's a pending subcategory to set, set it now
      if (pendingSubCategoryId && options.length > 0) {
        const subCategoryOption = options.find((item: any) => item.value === pendingSubCategoryId);
        if (subCategoryOption) {
          onChangeSubCategory(subCategoryOption);
          setPendingSubCategoryId(null); // Clear pending
        }
      }
    }
  }, [subCategories, pendingSubCategoryId]);

  // useEffect(() => {
  //   dispatch(fetchMeasuringUnits()).unwrap().then(async (data) => {
  //     if (data) {
  //       if (data.length > 0) {
  //         console.log(data);
  //         await data.forEach(async (item: string | any) => {
  //           console.log(item);
  //           setMeasuringUnitOptions((unitOptions: any) => ([...unitOptions, { label: `${item.name}(${item.unitCode})`, value: item._id }]));
  //         });
  //       }
  //     }
  //   });
  // }, []);

  // fetch current inventory details on edit
  useEffect(() => {
    if (inventoryId) {
      dispatch(fetchInventoryById(inventoryId));
    }
  }, [inventoryId, dispatch]);

  //Set edit estimate data in case of edit.
  useEffect(() => {
    const setInitialData = async () => {
      console.log(inventoryDetails);
      console.log(isEditing);
      try {
        if (inventoryDetails && isEditing) {
          console.log("inside isEditing and inventoryDetails ===> ");
          console.log(isEditing);
          setIsFormLoaded(true);
          setIsLoading(true);


          let _itemType = inventoryDetails.itemType == "Product" ? 1 : 2;
          methods.setValue('itemType', String(_itemType));
          methods.setValue('name', inventoryDetails.name);
          methods.setValue("description", inventoryDetails.description);

          // methods.setValue("category", inventoryDetails.category);
          // methods.setValue("subCategory", inventoryDetails.subCategory);

          methods.setValue('itemCode', inventoryDetails.itemCode);
          methods.setValue("hsnCode", inventoryDetails.hsnCode);

          methods.setValue('mrp', inventoryDetails.mrp);

          if (inventoryDetails.purchase) { 
            methods.setValue('purchasePrice', inventoryDetails.purchase.price);
            methods.setValue('purchaseWithTax', inventoryDetails.purchase.purchaseWithTax);
            // methods.setValue('purchaseUnit', inventoryDetails.purchaseUnit);
          }

          if (inventoryDetails.sale) {
            methods.setValue('salePrice', inventoryDetails.sale.price);
            methods.setValue('saleWithTax', inventoryDetails.sale.withTax);
            // methods.setValue('saleUnit', inventoryDetails.saleUnit);
          }

          methods.setValue('conversionRate', inventoryDetails.conversionRate);

          if (inventoryDetails.wholeSale) {
            methods.setValue('wholeSalePrice', inventoryDetails.wholeSale.price);
            methods.setValue('wholeSalePriceWithTax', inventoryDetails.wholeSale.withTax);
            methods.setValue('wholeSaleMinQty', inventoryDetails.wholeSale.minQty);
          }

          methods.setValue("gst", inventoryDetails.gst?._id);
          methods.setValue("taxRate", inventoryDetails.gst?._id);
          setSelectedTaxRateValue(inventoryDetails.gst?._id);

          if (inventoryDetails.discount) {  
            methods.setValue('discountPercent', inventoryDetails.discount.discountPercent);
            methods.setValue('discountAmount', inventoryDetails.discount.discountAmount);
            methods.setValue('discountAboveQty', inventoryDetails.discount.discountAboveQty);
          }

          if (inventoryDetails.stock) {
            methods.setValue('openingStock', inventoryDetails.stock.openingStock);
            methods.setValue('stockAsOfDate', inventoryDetails.stock.stockAsOfDate);
            methods.setValue('lowStockWarning', inventoryDetails.stock.lowStockWarning);
            methods.setValue('lowStockQuantity', inventoryDetails.stock.lowStockQuantity);
            methods.setValue('reorderQty', inventoryDetails.stock.reorderQty);
            methods.setValue('isRefrigerated', inventoryDetails.stock.isRefrigerated);
          }

          if (inventoryDetails.storeLocation) {
            methods.setValue('storeLocation', inventoryDetails.storeLocation.storeLocation);
            methods.setValue('storeName', inventoryDetails.storeLocation.storeName);
          }
          methods.setValue('brand', inventoryDetails.brand);
          methods.setValue('color', inventoryDetails.color);

          setGst(inventoryDetails.gst?._id || '');

          if (inventoryDetails.category) {
            var categoryValue = getCategoryOption(inventoryDetails.category?._id);
            console.log(categoryValue)
            onChangeCategory(categoryValue, true) // Pass true to skip clearing subcategory
          }

          if (inventoryDetails.subCategory) {
            // Set pending subcategory ID - will be set once subcategories load
            setPendingSubCategoryId(inventoryDetails.subCategory?._id);
          }

          if (inventoryDetails.sale && inventoryDetails.sale.unit) {
            var saleOptionValue = getUnitOptionValue(inventoryDetails.sale.unit?._id);
            console.log(saleOptionValue)
            onChangeSaleUnit(saleOptionValue)
          }
          
          if (inventoryDetails.purchase && inventoryDetails.purchase.unit) {
            var purchaseOptionValue = getUnitOptionValue(inventoryDetails.purchase.unit?._id);
            console.log(purchaseOptionValue)
            onChangePurchaseUnit(purchaseOptionValue)
          }

          let _parentSkuIds;
          let _parenteSkuTags;
          if (inventoryDetails.parentSkus && inventoryDetails.parentSkus.length > 0) {
            _parentSkuIds = inventoryDetails.parentSkus.map((sku:any) => sku._id)
            _parenteSkuTags = inventoryDetails.parentSkus.map((sku:any) => {return {value: sku._id, label: sku.name} })
          } else {
            _parentSkuIds = [];
            _parenteSkuTags = []
          }
          setParentSkus(_parentSkuIds);
          setSelectedParentSkuTags(_parenteSkuTags);

          setIsLoading(false);
          setIsFormLoaded(false);
        }
      } catch (error: any) {
        console.log("setInitialData catch block called");
        console.log(error);
      }
    };

    if (Object.keys(inventoryDetails).length > 0) setInitialData();
  }, [methods, dispatch, inventoryDetails, isEditing, selectedAccount, type]);

  const onChangeCategory = (data: any, skipClearSubCategory = false) => {
    console.log(data);
    methods.setValue("category", data.value);

    console.log(isEditing);

    // Fetch subcategories for the selected category
    if (data && data.value) {
      dispatch(fetchItemSubCategoriesByCategory(data.value));
      setItemCategoryId(data.value);
    }

    // Only clear subcategory if not loading initial data
    if (!skipClearSubCategory) {
      setItemSubCategoryId('');
      setItemSubCategoryValue(null);
      setItemSubCategoryOptions([]);
      methods.setValue("subCategory", '');
    }

    setItemCategoryValue(data);
    setItemCategoryId(data.value);
  }

  const onChangeItemCategoryHandler = (event: any, value: any) => {
    console.log("Called onChangeItemCategoryHandler -----");
    methods.setValue("category", event.target.value);
    setItemCategoryId(event.target.value);

    methods.setValue("subCategory", '');
    setItemSubCategoryId('');
    // setItemSubCategoryOptions([]);
    console.log(itemCategoryId);
    
  }

  const onChangeSubCategory = (data: any) => {
    console.log(data);
    methods.setValue("subCategory", data.value);
    setItemSubCategoryValue(data)
    setItemSubCategoryId(data.value);
  }

  const onChangeSaleUnit = (data: any) => {
    console.log(data);
    console.log(data);
    setItemMeasuringUnitValue(data)
    setItemMeasuringUnitId(data.value);
    methods.setValue('saleUnit', data.value)
  }

  const onChangePurchaseUnit = (data: any) => {
    console.log(data);
    setItemPurchaseUnitValue(data)
    setItemPurchaseUnitId(data.value);
    methods.setValue('purchaseUnit', data.value)
  }

  const getCategoryOption = (id: any) => {
    console.log(itemCategoryOptions);
    console.log(id);
    let categoryOption = itemCategoryOptions.find((item: any) => item.value == id);
    console.log(categoryOption);
    return categoryOption ? categoryOption : {}
  }
  const getSubCategoryOption = (id: any, categoryId: any) => {
    console.log(itemSubCategoryOptions);
    console.log(id);

    var _options;
    if (itemSubCategoryOptions.length == 0) {
      // _options = getItemSubCategory(categoryId);
    }
    let subCategoryOption = itemSubCategoryOptions.find((item: any) => item.value == id);
    console.log(subCategoryOption);
    return subCategoryOption ? subCategoryOption : {}
  }

  const getUnitOptionValue = (id: any) => {
    console.log(measuringUnitOptions);
    console.log(id);
    let unitOption = measuringUnitOptions.find((item: any) => item.value == id);
    console.log(unitOption);
    return unitOption ? unitOption : {}
  }

  const onChangeTagSkus = (data: any) => {
    console.log(data);
    setSelectedParentSkuTags(data);
    const tagedSkus = data.map((item:any) => item.value);
    const uniqueArray = [...new Set(tagedSkus)]
    let arrayValue:any = []
    uniqueArray.forEach((item) => { arrayValue.push(String(item));});
    if (uniqueArray && uniqueArray.length > 0) {
      setParentSkus(arrayValue);
    }
  }

  return (
      <FormProvider {...methods}>
        
        {/* <CardContent className={'invoiceContent'}> */}
          {/* <Typography className={'cardHeader'} variant="body1" >
            <Box>{isEditing ? "Edit Inventory" : "Create New Item"}</Box>
          </Typography> */}

          <Box component="form" onSubmit={methods.handleSubmit(data => onSubmit(data))} ref={formRef} noValidate sx={model ? style : {borderRadius:'12px', border:'3px solid #e9ecf1',backgroundColor:'#fff',margin:0, mt:9}}>
            {isformLoaded && <StyledBoxLoader sx={{ mt: 1 }}><CircularProgress color="inherit" /></StyledBoxLoader>}
            <LocalizationProvider dateAdapter={AdapterDateFns}>

            {model ? <Grid container>
                <Grid {...{ xs: 12, sm: 8, md: 4, lg: 12, p:2, pl:2, bgcolor:'#e9ecf1' }} style={{borderTopLeftRadius:8,borderTopRightRadius:8,height:50}} >
                <div style={{float:'right',marginTop:-7,marginRight:-5}}>
                    <IconButton size='small' type="submit"
                    name={'submit'}>
                        <CheckCircleOutlineOutlinedIcon  color="primary"/>
                    </IconButton>
                    <IconButton size='small' 
                    onClick={onClose} 
                    style={{marginRight:-5}} >
                        <HighlightOffOutlinedIcon  color="error"/>
                    </IconButton>
                </div> 
                <h3  style={{marginTop:-2}}>Create Item</h3>
                </Grid>
            </Grid> :
            
            <Grid container p={0} spacing={2} position={'fixed'} mt={-11.4} ml={-2.4} zIndex={0}>
            <Grid item xs={8}>
              <Box sx={{borderRadius:'12px', border:'3px solid #e9ecf1',backgroundColor:'#fff'}}>
              <Grid container>
                  <Grid {...{ xs: 12, sm: 8, md: 4, lg: 12, p:2, pl:2,pt:1.5, bgcolor:'#e9ecf1' }} style={{borderTopLeftRadius:8,borderTopRightRadius:8,height:50}} >
                                      <div style={{float:'right',marginTop:-5,marginRight:-5}}>
                                      {<LoadingButton
                                        className={'buttonContainedRoot'}
                                        size='small'
                                        type="submit"
                                        name={'submit'}
                                        loading={status === ApiStatus.LOADING}
                                        style={{ color:'#488dff',backgroundColor:'#fff',border:'0.5px solid #488dff',height:35,borderRadius:7}}
                                        variant="contained"
                                      >
                                        { isEditing ? "Update" : "Create"}
                                      </LoadingButton>}
                                      </div>
                      <IconButton onClick={() => {
                          methods.reset();
                          onCancel();
                        }} 
                        style={{float:'left', color:'#545454',backgroundColor:'#f5f5f5',border:'none',height:35,width:35,marginTop:-5,marginRight:10,marginLeft:-5 }}
                        size='small'
                      >
                        <NavigateBeforeOutlinedIcon style={{fontSize:20}}/>
                      </IconButton>
                      <h3  style={{marginTop:-1,fontWeight:600}}>{ isEditing ? "Edit Item" : "New Item"}</h3>
                      </Grid>
              </Grid>
              </Box>
              </Grid>
              </Grid>}
            
            <Grid container spacing={2} p={2}>
              <Grid item xs={2} pr={2}>
                <h5 className='c-label' style={{fontSize:14,marginBottom:10}}>Item Type*</h5>
                <div className={`${selectedIndex === 1 ? 'item-menu-active' :'item-menu'}`} onClick={()=> {
                    handleListItemClick(1);
                    setItemType1(1);
                  }}>
                  <BpRadio {...methods.register("itemType")} checked={itemType1 === 1} onChange={()=> {
                    handleListItemClick(1);
                    setItemType1(1);
                  }} size="small" style={{marginRight:-10}}/>
                  <label>Product</label>
                </div>
                <div className={`${selectedIndex === 2 ? 'item-menu-active' :'item-menu'}`} onClick={()=> {
                    handleListItemClick(2);
                    setItemType1(2);
                  }}>
                  <BpRadio {...methods.register("itemType")} checked={itemType1 === 2} onChange={()=> {
                    handleListItemClick(2);
                    setItemType1(2);
                  }} size="small" style={{marginRight:-10}}/>
                  <label>Service</label>
                </div>
                <Divider style={{marginBottom:10}}/>
                <div className={`${selectedIndex === 3 ? 'item-menu-active' :'item-menu'}`} style={{paddingTop:5}} onClick={()=>handleListItemClick(3)}>
                  <label>Photos</label>
                </div> 
                <div className={`${selectedIndex === 4 ? 'item-menu-active' :'item-menu'}`} style={{paddingTop:5}} onClick={()=>handleListItemClick(4)}>
                  <label>Custom Fields</label>
                </div> 
                <div className={`${selectedIndex === 5 ? 'item-menu-active' :'item-menu'}`} style={{paddingTop:5}} onClick={()=>handleListItemClick(5)}>
                  <label>Linked Products</label>
                </div> 
          
                <div className={`${selectedIndex === 6 ? 'item-menu-active' :'item-menu'}`} style={{paddingTop:5}} onClick={()=>handleListItemClick(6)}>
                  <label>Barcode</label>
                </div>
              </Grid>
              <Grid item xs={10} mr={0} pr={1} mt={2} style={{borderLeft:'1px solid #e9ecf1',minHeight:595,maxHeight:618, overflowY:'hidden', overflowX:'hidden'}}>
            <Grid container spacing={2} mt={-4}> 

            
              {selectedIndex === 1 || selectedIndex === 2 ? <>
                <Grid item xs={4}>
                  <h5 className='c-label2'>{selectedIndex === 1 ? "Item" : "Service"} Name*</h5>
                  <TextField 
                      placeholder={selectedIndex === 1 ? "Item Name" : "Service Name"} 
                      required
                      // error={!!methods.formState.errors}
                      // helperText={methods.formState.errors.name?.message ?? ""}
                      {...methods.register("name")}
                      name='name'
                      className='c-text-field' 
                      variant="standard" 
                      sx={{width:'100%'}} 
                      // size='small'
                      InputProps={{
                      disableUnderline: true, 
                      }}
                  />
                  <p style={{color: "red"}}>{methods.formState.errors.name?.message ?? ""}</p>
                </Grid>

                <Grid item xs={4}>
                  <h5 className='c-label2'>{selectedIndex === 1 ? "Item" : "Service"} Category</h5>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box sx={{ flex: 1 }}>
                      <Autocomplete
                        id="itemCategoryOptionsAutocomplete"
                        disablePortal
                        value={itemCategoryValue}
                        options={itemCategoryOptions && itemCategoryOptions.map(e =>({ value: e.value, label: e.label }))}
                        getOptionLabel={(option) => option.label}
                        onChange={(event, value) => onChangeCategory(value)}
                        renderOption={(props, option: {label: string, value: string}) => (
                          <li {...props} 
                          style={{
                            fontSize:14,
                            height:40,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                          }}
                          >
                            <span>{option.label}</span>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                const categoryToEdit = itemCategoryOptions.find(cat => cat.value === option.value);
                                handleOpenCategoryModal(false, categoryToEdit, null);
                              }}
                              sx={{ 
                                color: '#488dff', 
                                minWidth: '24px', 
                                height: '24px',
                                fontWeight: 'normal',
                                '&:hover': {
                                  backgroundColor: 'rgba(72, 141, 255, 0.1)'
                                }
                              }}
                              title="Edit Category"
                            >
                              <EditIcon fontSize="small" sx={{ fontWeight: 'normal' }} />
                            </IconButton>
                          </li>
                        )}
                        classes={{ paper: classes.paper }}
                        sx={{ width: '100%'}}
                        renderInput={(params) => <TextField {...params}
                        placeholder={selectedIndex === 1 ? "Select Item Category" : "Select Service Category"}
                          required 
                          className='c-text-field' 
                          variant="standard" 
                          size='small'
                          InputProps={{...params.InputProps, disableUnderline: true}}
                        />}
                      />
                    </Box>
                    <IconButton
                      size="small"
                      onClick={() => handleOpenCategoryModal(false)}
                      sx={{ color: '#488dff', minWidth: '32px', height: '32px' }}
                      title="Add Category"
                    >
                      <AddIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </Grid>


                <Grid item xs={4}>
                  <h5 className='c-label2'>{selectedIndex === 1 ? "Item" : "Service"} Sub Category</h5>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box sx={{ flex: 1 }}>
                      <Autocomplete
                        id="itemSubCategoryOptionsAutocomplete"
                        disablePortal
                        value={itemSubCategoryValue}
                        options={itemSubCategoryOptions && itemSubCategoryOptions.map(e =>({ value: e.value, label: e.label }))}
                        getOptionLabel={(option) => option.label}
                        onChange={(event, value) => onChangeSubCategory(value)}
                        renderOption={(props, option: {label: string, value: string}) => (
                          <li {...props} 
                          style={{
                            fontSize:14,
                            height:40,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                          }}
                          >
                            <span>{option.label}</span>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                const subCategoryToEdit = subCategories.find(sub => sub._id === option.value);
                                console.log('Editing subcategory:', subCategoryToEdit);
                                console.log('Available subCategories:', subCategories);
                                handleOpenCategoryModal(true, null, subCategoryToEdit);
                              }}
                              sx={{ 
                                color: '#488dff', 
                                minWidth: '24px', 
                                height: '24px',
                                fontWeight: 'normal',
                                '&:hover': {
                                  backgroundColor: 'rgba(72, 141, 255, 0.1)'
                                }
                              }}
                              title="Edit Sub Category"
                            >
                              <EditIcon fontSize="small" sx={{ fontWeight: 'normal' }} />
                            </IconButton>
                          </li>
                        )}
                        classes={{ paper: classes.paper }}
                        sx={{ width: '100%'}}
                        renderInput={(params) => <TextField {...params}
                          placeholder={selectedIndex === 1 ? "Select Sub Category" : "Select Service Sub Category"}
                          className='c-text-field' 
                          variant="standard" 
                          size='small'
                          InputProps={{...params.InputProps, disableUnderline: true}}
                        />}
                      />
                    </Box>
                    <IconButton
                      size="small"
                      onClick={() => handleOpenCategoryModal(true, null, null)}
                      sx={{ color: '#488dff', minWidth: '32px', height: '32px' }}
                      title="Add Sub Category"
                    >
                      <AddIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </Grid>

                <Grid item xs={12} mt={-1}>
                  <h5 className='c-label2'>Description (Optional)</h5>
                  <TextField 
                    className='c-text-field' 
                    variant="standard" 
                    multiline
                    {...methods.register("description")}
                    minRows={3}
                    maxRows={3}
                    style={{width:'100%'}}
                    // onChange={(v)=> setInvoiceItemText(v.target.value.toString(), 'description', e.id)}
                    // onDoubleClick={() => Editable(e.id, true)}
                    placeholder='Description (Optional)'
                    InputProps={{
                      disableUnderline: true,
                      style:{
                        fontSize:14,
                      },
                    }} 
                  />
                </Grid>

                

                

                <Grid item xs={12} mt={-1}>
                <Divider><Chip label="Pricing Details" size="small" /></Divider>
                </Grid>

                {selectedIndex === 1 ? <>
                <Grid item xs={4} mt={-1}>
                <h5 className='c-label2'>Maximum Retail Price (MRP)</h5>
                <TextField
                  className='c-text-field'
                  placeholder="Maximum Retail Price (MRP)"
                  variant="standard"
                  {...methods.register("mrp")}
                  onChange={(e) => {
                    const _mrpValue = Number(e.target.value);
                    methods.setValue("mrp", e.target.value);
                    
                    const discountPercent = Number(methods.getValues("discountPercent"));
                    if (_mrpValue && _mrpValue > 0 && discountPercent > 0) {
                      const _discountAmount = _mrpValue * discountPercent / 100;
                      methods.setValue("discountAmount", _discountAmount);
                      methods.setValue("salePrice", (_mrpValue - _discountAmount).toString());
                    }

                    if (e.target.value && mrpWarning) {
                      setMrpWarning("");
                    }
                  }}
                  style={{width:'100%'}}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    },
                  }}
                />
                </Grid>
                <Grid item xs={4} mt={-1}>
                  <h5 className='c-label2'>Discount (%)</h5>
                  <TextField
                    className='c-text-field'
                    placeholder="Discount Percentage)"
                    variant="standard"
                    type='number'
                    {...methods.register("discountPercent")}
                    style={{width:'100%'}}
                    onChange={(e) => {
                      const mrp = Number(methods.getValues("mrp"));
                      var _value =  Number(e.target.value);

                      if (_value && _value > 0) {
                        if (!mrp || mrp === 0) {
                          setMrpWarning("MRP is required to calculate discount");
                          methods.setValue("discountAmount", 0);
                        } else {
                          setMrpWarning("");
                          if (_value <= 100) {
                            var _discountAmount = mrp * _value / 100;
                            methods.setValue("discountAmount", _discountAmount);
                            methods.setValue("salePrice", (mrp - _discountAmount).toString());
                          } else {
                            methods.setValue("discountAmount", 0);
                          }
                        }
                      } else {
                        setMrpWarning("");
                        methods.setValue("discountAmount", 0);
                      }
                    }}
                    InputProps={{
                      disableUnderline: true,
                      style:{
                        fontSize:14,
                        height:28
                      },
                    }}
                  />
                  <p style={{color: "red", marginTop: 5}}>{mrpWarning}</p>
                </Grid>
                <Grid item xs={4} mt={-1}>
                <h5 className='c-label2'>Discount Amount</h5>
                <TextField 
                  className='c-text-field' 
                  placeholder="Discount Amount"
                  variant="standard"
                  disabled
                  type='number'
                  {...methods.register("discountAmount")} 
                  style={{width:'100%'}}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    },
                  }}
                />
                </Grid>
                </> : ''}

                <Grid item xs={4} mt={-1}>
                  <h5 className='c-label2'>{Number(methods.watch("discountPercent")) > 0 ? "Discounted Sale Price" : "Sale Price"}</h5>
                  <TextField
                    className='c-text-field'
                    variant="standard"
                    style={{width:'100%'}}
                    {...methods.register("salePrice")}
                    // onChange={(value) => { methods.setValue("mrp", value.target.value.toString()) }}
                    InputProps={{
                      disableUnderline: true,
                      style:{
                        fontSize:14,
                        height:28
                      },
                      startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:14}}>&nbsp;&nbsp;₹</b></InputAdornment>,
                      endAdornment: <InputAdornment position="end">
                        <Select
                          className='c-text-field-2'
                          value={2}
                          {...methods.register("saleWithTax")}
                          disableUnderline
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                border: "1.5px solid #e9ecf1",
                                width: 120,
                                boxShadow: 'none',
                                borderRadius: '5px'
                              }
                            }
                            }}
                          style={{width:125}}
                          // size='small'
                          variant='outlined'
                          sx={{
                            boxShadow: "none",
                            fontSize:14,
                          //   height:28,
                            textAlign:'left',
                            '& .MuiOutlinedInput-input': {p: 0},
                            '& .MuiSelect-select': { p:0 },
                            marginBottom:'2px',
                            ".MuiOutlinedInput-notchedOutline": { border: 0 },
                            "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                              {
                                border: 0,
                              },
                            "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                              {
                                border: 0,
                              },
                          }}
                        >
                          <MenuItem value={1} >With Tax</MenuItem>
                          <MenuItem value={2} selected={true}>Without Tax</MenuItem>
                        </Select>
                      </InputAdornment>,
                    }}
                  />
                </Grid>
                {selectedIndex === 1 ? <>
                <Grid item xs={4} mt={-1}>
                <h5 className='c-label2'>Purchase Price</h5>
                <TextField
                  className='c-text-field'
                  variant="standard"
                  style={{width:'100%'}}
                  {...methods.register("purchasePrice")}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    },
                    startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:14}}>&nbsp;&nbsp;₹</b></InputAdornment>,
                    endAdornment: <InputAdornment position="end">
                      <Select
                        className='c-text-field-2'
                        value={2}
                        disableUnderline
                        {...methods.register("purchaseWithTax")}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              border: "1.5px solid #e9ecf1",
                              width: 120,
                              boxShadow: 'none',
                              borderRadius: '5px'
                            }
                          }
                          }}
                        style={{width:125}}
                        // size='small'
                        variant='outlined'
                        sx={{
                          boxShadow: "none",
                          fontSize:14,
                        //   height:28,
                          textAlign:'left',
                          '& .MuiOutlinedInput-input': {p: 0},
                          '& .MuiSelect-select': { p:0 },
                          marginBottom:'2px',
                          ".MuiOutlinedInput-notchedOutline": { border: 0 },
                          "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                            {
                              border: 0,
                            },
                          "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                            {
                              border: 0,
                            },
                        }}
                      >
                        <MenuItem value={1}>With Tax</MenuItem>
                        <MenuItem value={2}>Without Tax</MenuItem>
                      </Select>
                    </InputAdornment>,
                  }}
                />
                </Grid>

                

                
                <Grid item xs={4} mt={-1}>
                <h5 className='c-label2'>Discount Above Qty</h5>
                <TextField 
                  className='c-text-field' 
                  placeholder="Discount Above Qty"
                  variant="standard"
                  type='number'
                  {...methods.register("discountAboveQty")} 
                  // onChange={(value) => { methods.setValue("salePrice", value.target.value.toString()) }}
                  style={{width:'100%'}}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    },
                  }}
                />
                </Grid></> : ''}

                <Grid item xs={4} mt={-1}>
                <h5 className='c-label2'>Tax Rate(%)</h5>
                <Select
                        className='c-text-field'
                        disableUnderline
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              border: "1.5px solid #e9ecf1",
                              // width: 255,
                              // marginLeft:'-29px !important',
                              boxShadow: 'none',
                              borderRadius: '5px'
                            }
                          }
                          }}
                        style={{width:'100%'}}
                        value={selectedTaxRateValue ?? ''}
                        {...methods.register("gst")}
                        onChange={(event: SelectChangeEvent<any>) => {
                          methods.setValue("gst", event.target.value);
                          setSelectedTaxRateValue(event.target.value);
                        }}
                        variant='outlined'
                        sx={{
                          boxShadow: "none",
                          // fontSize:12,
                          '& .MuiOutlinedInput-input': {p: 0.5},
                          // '& .MuiSelect-select': { p:0 },
                          marginBottom:'3px',
                          ".MuiOutlinedInput-notchedOutline": { border: 0 },
                          "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                            {
                              border: 0,
                            },
                          "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                            {
                              border: 0,
                            },
                        }}
                      >
                       
                        {taxRateOptions && taxRateOptions.map((option)=>
                          <MenuItem value={option.value} key={option.value}>{option.label}</MenuItem>
                        )}
                        </Select>
                </Grid>

                {selectedIndex === 1 ? !wholesale ? <>
                <Grid item xs={8} mt={2}>
                    
                    <label className="c_label" style={{color:'#488dff',cursor:'pointer',fontSize:14}}
                    onClick={()=> setWholesale(!wholesale)}>+ Add Wholesale Rate (Optional)</label>
                </Grid></>: 
                <Grid item xs={8} mt={-1}>
                <>
                <HighlightOffTwoToneIcon 
                onClick={()=> {
                    setWholesale(false);
                }} sx={{float:'right',marginTop:'0px',marginRight:-1 ,color:'#9da7b7',fontSize:20}}/>
                <Box sx={{ p: 0, border: '1px dashed grey', borderRadius:'10px', m:0, mt:1, transition:'0.5s'}} >
                <Grid container spacing={2} p={1} pt={0}>
                <Grid item xs={6} mt={-2.5}>
                <h5 className='c-label2'>Wholesale Price</h5>
                <TextField 
                  className='c-text-field' 
                  variant="standard"
                  style={{width:'100%'}}
                  {...methods.register("wholeSalePrice")}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    },
                    startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:14}}>&nbsp;&nbsp;₹</b></InputAdornment>,
                    endAdornment: <InputAdornment position="end">With Tax</InputAdornment>,
                  }}  
                />
                </Grid>
                <Grid item xs={6} mt={-2.5}>
                <h5 className='c-label2'>Wholesale Quantity</h5>
                <TextField 
                  className='c-text-field' 
                  variant="standard"
                  style={{width:'100%'}}
                  {...methods.register("wholeSaleMinQty")}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    },
                    // startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:14}}>&nbsp;&nbsp;₹</b></InputAdornment>,
                    endAdornment: <InputAdornment position="start">FT</InputAdornment>,
                  }}  
                />
                </Grid>
                </Grid>
                </Box>
                </>
                </Grid> : ''}

                <Grid item xs={12} mt={-1}>
                <Divider><Chip label={selectedIndex === 1 ? "Stock Details" : "Other Details"} size="small" /></Divider>
                </Grid>

                {selectedIndex === 1 ? <>
                <Grid item xs={4}  mt={-1}>
                  <h5 className='c-label2'> Sale Unit</h5>
                  <Autocomplete
                    id="saleUnitOptionsAutocomplete222"
                    disablePortal
                    value={itemMeasuringUnitValue}
                    options={measuringUnitOptions && measuringUnitOptions.map(e =>({ value: e.value, label: e.label }))}
                    getOptionLabel={(option) => option.label}
                    onChange={(event, value) => onChangeSaleUnit(value)}
                    renderOption={(props, option: {label: string}) => (
                      <li {...props} 
                      style={{fontSize:14,height:30, borderBottom: "1px solid #cdccccb8"}}
                      >{option.label}</li>
                    )}
                    classes={{ paper: classes.paper }}
                    sx={{ width: '100%'}}
                    renderInput={(params) => <TextField {...params}
                      placeholder="Select Sale Unit"
                      required
                      className='c-text-field' 
                      variant="standard" 
                      size='small'
                      InputProps={{...params.InputProps, disableUnderline: true}}
                    />}
                  />
                </Grid>

                <Grid item xs={4}  mt={-1}>
                  <h5 className='c-label2'>Purchase Unit</h5>
                  <Autocomplete
                    id="purchaseUnitOptionsAutocomplete222"
                    disablePortal
                    value={itemPurchaseUnitValue}
                    options={measuringUnitOptions && measuringUnitOptions.map(e =>({ value: e.value, label: e.label }))}
                    getOptionLabel={(option) => option.label}
                    onChange={(event, value) => onChangePurchaseUnit(value)}
                    renderOption={(props, option: {label: string}) => (
                      <li {...props} 
                      style={{fontSize:14,height:30, borderBottom: "1px solid #cdccccb8" }}
                      >{option.label}</li>
                    )}
                    classes={{ paper: classes.paper }}
                    sx={{ width: '100%'}}
                    renderInput={(params) => <TextField {...params}
                      placeholder="Select Sale Unit"
                      required
                      className='c-text-field' 
                      variant="standard" 
                      size='small'
                      InputProps={{...params.InputProps, disableUnderline: true}}
                    />}
                  />
                </Grid>

                <Grid item xs={4} mt={-1}>
                <h5 className='c-label2'>Convertion Rate</h5>
                <TextField 
                  className='c-text-field' 
                  placeholder={"Enter Convertion Rate"}
                  variant="standard"
                  {...methods.register("conversionRate")}
                  style={{width:'100%'}}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    },
                    startAdornment: selectedIndex === 1 ? <InputAdornment position="start"><a style={{paddingBottom:3,fontSize:14}}>1 PCS = </a></InputAdornment> : '',
                    endAdornment: selectedIndex === 1 ? <InputAdornment position="start"><a style={{paddingBottom:3,fontSize:14}}>UNIT</a></InputAdornment> : '',
                  }}  
                />
                </Grid>
                
                <Grid item xs={4} mt={-1}>
                <h5 className='c-label2'>Opening Stock 
                  {isEditing && <Tooltip title="You cannot update opening stock. If you want udpate the stock please use Adjust Stock"><InfoIcon style={{ fontSize: '12px', color: '#09b2ee', width: '15px' }}></InfoIcon></Tooltip>}</h5>
                <TextField 
                  className='c-text-field' 
                  variant="standard"
                  type='number'
                  style={{width:'100%'}}
                  disabled={isEditing}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    }
                  }} 
                  {...methods.register("openingStock")} 
                />
                </Grid>

                <Grid item xs={4} mt={-1} >
              <h5 className='c-label2'>As Of Date *</h5>
              <DesktopDatePicker
                inputFormat="dd/MM/yyyy"
                maxDate={moment().add(1).toDate()}
                value={stockAsOfDate}
                
                InputProps={{
                  disableUnderline: true,
                  style:{
                    fontSize:14,
                    height:28
                  },
                }}
                onChange={(value) => { handleDateChange(value, 'stockAsOfDate') }}
                renderInput={(params) => 
                  <TextField {...params}
                    {...methods.register("stockAsOfDate")} 
                    style={{width:'100%'}}
                    required 
                    variant="standard"
                    className='c-text-field'
                    placeholder="Invoice Date"
                    
                  />}
              />
              </Grid></> : ''}

              {selectedIndex === 1 ? !lowStock ? <>
                <Grid item xs={4} mt={2}>
                    
                    <label className="c_label" style={{color:'#488dff',cursor:'pointer',fontSize:14}}
                    onClick={()=> setLowStock(!lowStock)}>+ Add Low Stock Quantity (Optional)</label>
                </Grid></>: 
                <Grid item xs={4} mt={-1}>
                <>
                <HighlightOffTwoToneIcon 
                onClick={()=> {
                    setLowStock(false);
                }} sx={{float:'right',marginTop:'0px',marginRight:-1 ,color:'#9da7b7',fontSize:20}}/>
                <Box sx={{ p: 0, border: '1px dashed grey', borderRadius:'10px', m:0, mt:1, transition:'0.5s' }} >
                <Grid container spacing={2} p={1} pt={0}>
                <Grid item xs={12} mt={-2.5}>
                <h5 className='c-label2'>Low Stock Quantity</h5>
                <TextField 
                  className='c-text-field' 
                  variant="standard"
                  {...methods.register("lowStockQuantity")} 
                  style={{width:'100%'}}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    }
                  }}  
                />
                </Grid>
                </Grid>
                </Box>
                </>
                </Grid> : ''}

              <Grid item xs={4} mt={lowStock ? -4.1 : -1}>
                <h5 className='c-label2'>{selectedIndex === 1 ? "Item Code" : "Service Code"}</h5>
                <TextField 
                  className='c-text-field' 
                  placeholder={selectedIndex === 1 ? "Item Code" : "Service Code"}
                  variant="standard"
                  {...methods.register("itemCode")}
                  style={{width:'100%'}}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    },
                    // endAdornment: selectedIndex === 1 ? <InputAdornment position="start"><a style={{paddingBottom:3,fontSize:14}}>Generate Barcode</a></InputAdornment> : '',
                  }}  
                />
                </Grid>

              <Grid item xs={4} mt={lowStock ? -4.1 : -1}>
                <h5 className='c-label2'>{selectedIndex === 2 ? 'SAC' : 'HSN'} Code</h5>
                <TextField 
                  className='c-text-field' 
                  placeholder={selectedIndex === 2 ? 'SAC Code' : 'HSN Code'}
                  variant="standard"
                  {...methods.register("hsnCode")} 
                  style={{width:'100%'}}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    },
                  }}  
                />
                </Grid>

                </> : ''}

                {selectedIndex === 3 ? <>
                  <Grid item xs={12} mt={0}>
                <Divider><Chip label={"Item Photos"} size="small" /></Divider>
                </Grid>
                <div style={{padding:20}}>
                <FileUploader
                  images={images}
                  title='Upload Photos'
                  size={5}
                  setImages={setImages}
                ></FileUploader></div> </>: ''}

                {selectedIndex === 4 ? <>

                <Grid item xs={12} mt={0}>
                <Divider><Chip label={"Additional Fields"} size="small" /></Divider>
                </Grid>
                <Grid item xs={4} mt={-1}>
                <h5 className='c-label2'>Brand</h5>
                <TextField 
                  className='c-text-field' 
                  placeholder="Brand"
                  variant="standard"
                  {...methods.register("brand")}
                  style={{width:'100%'}}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    },
                    // endAdornment: selectedIndex === 1 ? <InputAdornment position="start"><a style={{paddingBottom:3,fontSize:14}}>Generate Barcode</a></InputAdornment> : '',
                  }}  
                />
                </Grid>
                <Grid item xs={4} mt={-1}>
                <h5 className='c-label2'>Color</h5>
                <TextField 
                  className='c-text-field' 
                  placeholder="Color"
                  variant="standard"
                  {...methods.register("color")}
                  style={{width:'100%'}}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    },
                    // endAdornment: selectedIndex === 1 ? <InputAdornment position="start"><a style={{paddingBottom:3,fontSize:14}}>Generate Barcode</a></InputAdornment> : '',
                  }}  
                />
                </Grid>
                <Grid item xs={4} mt={-1}>
                <h5 className='c-label2'>Store Location</h5>
                <TextField 
                  className='c-text-field' 
                  placeholder="Store Location"
                  variant="standard"
                  {...methods.register("storeLocation")}
                  style={{width:'100%'}}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    },
                  }}  
                />
                </Grid>
                <Grid item xs={4} mt={-1}>
                <h5 className='c-label2'>Store Name</h5>
                <TextField 
                  className='c-text-field' 
                  placeholder="Store Name"
                  variant="standard"
                  {...methods.register("storeName")}
                  style={{width:'100%'}}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    },
                  }}  
                />
                </Grid>

                <Grid item xs={12} mt={0}>
                <Divider><Chip label={"Custom Fields"} size="small" /></Divider>
                </Grid>

                <Grid item xs={4} mt={0}>
                <h5 className='c-label2'>Custom Field Name</h5>
                <TextField 
                  className='c-text-field' 
                  variant="standard" 
                //   size='small'
                  style={{width:'100%'}}
                //   value={invoice.receivedAmt}
                //   onChange={(e) => {
                //     const s = {...invoice};
                //     s.receivedAmt = e.target.value;
                //     setInvoice(s)
                //   }}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    },
                    // startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:14}}>&nbsp;&nbsp;₹</b></InputAdornment>,
                    // endAdornment: <InputAdornment position="end">With Tax</InputAdornment>,
                  }}  
                />
                </Grid>
                <Grid item xs={4} mt={0}>
                <h5 className='c-label2'>Custom Field Value</h5>
                <TextField 
                  className='c-text-field' 
                  variant="standard" 
                //   size='small'
                  style={{width:'100%'}}
                //   value={invoice.receivedAmt}
                //   onChange={(e) => {
                //     const s = {...invoice};
                //     s.receivedAmt = e.target.value;
                //     setInvoice(s)
                //   }}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    },
                    // startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:14}}>&nbsp;&nbsp;₹</b></InputAdornment>,
                    // endAdornment: <InputAdornment position="start">FT</InputAdornment>,
                  }}  
                />
                </Grid>
                <Grid item xs={4} mt={3}>
                    <label className="c_label" style={{color:'#488dff',cursor:'pointer',fontSize:14}}
                    // onClick={()=> setLowStock(!lowStock)}
                    >+ Add Another Field</label>
                </Grid>
                </> : ''}

                {selectedIndex === 5 ? <>
                  <Grid item xs={12} mt={0}>
                    <Alert severity="info" style={{fontSize: 16}}>Select list of products for cross selling. This feature allows you to suggest linked items while adding items to invoice from inventory</Alert>
                  </Grid>
                  <Grid item xs={12} mt={0}>
                    <h5 className='c-label2'>Tag Inventory Items</h5>
                    <Autocomplete
                      id="parentSkusOptionsAutocomplete"
                      multiple
                      disablePortal
                      value={selectedParentSkuTags}
                      options={skuOptions && skuOptions.map(e =>({ value: e.value, label: e.label }))}
                      // options={skuOptions.filter(option => !selectedParentSkuTags.includes(option))}
                      getOptionLabel={(option) => option.label}
                      onChange={(event, value) => onChangeTagSkus(value)}
                      renderOption={(props, option: {label: string}) => (
                        <li {...props} 
                        style={{fontSize:14}}
                        >{option.label}</li>
                      )}
                      classes={{ paper: classes.paper }}
                      sx={{ width: '100%'}}
                      renderInput={(params) => <TextField {...params}
                      placeholder={"Tag Inventory Items"}
                        style={{height: 'auto'}}
                        required 
                        className='c-text-field-4' 
                        variant="standard" 
                        size='small'
                        InputProps={{...params.InputProps, disableUnderline: true}}
                      />}
                    />
                  </Grid>
                  <div style={{padding:20}}>

                  </div> 
                  </> : ''
                }

                {selectedIndex === 6 ? <>
                  {/* <Grid item xs={12} mt={0}>
                    <Divider><Chip label={"Product Barcode"} size="small" /></Divider>
                  </Grid> */}
                  <Grid item xs={12} mt={1}>
                    <Alert severity="info" style={{fontSize: 16}}>
                      Generate and manage barcode for this product. Barcodes can be used for inventory tracking, sales, and product identification.
                    </Alert>
                  </Grid>
                  
                  {/* Current barcode display or generation */}
                  <Grid item xs={12} mt={2}>
                    <BarcodeDisplay
                      accountId={selectedAccount._id}
                      objectId={isEditing ? inventoryId! : 'new-item'}
                      skuData={{
                        name: methods.watch('name') || 'New Item',
                        itemCode: methods.watch('itemCode') || '',
                        hsn: methods.watch('hsnCode') || '',
                        mrp: Number(methods.watch('mrp')) || 0,
                        salePrice: Number(methods.watch('salePrice')) || 0,
                        barCodeImage: methods.watch('barCodeImage') || ''
                      }}
                      variant="detailed"
                      showActions={true}
                      showItemInfo={true}
                      autoGenerate={false}
                      width={300}
                      height={90}
                      onBarcodeGenerated={(barcodeData) => {
                        console.log('Barcode generated:', barcodeData);
                        // Update form with generated barcode image
                        methods.setValue('barCodeImage', barcodeData.barCodeImage);
                      }}
                      onError={(error) => {
                        console.error('Barcode error:', error);
                        // You can show error message here
                      }}
                    />
                  </Grid>
                  
                  <Grid item xs={12} mt={2}>
                    <Typography variant="body2" color="text.secondary">
                      <strong>Usage Instructions:</strong><br />
                      • Click "Generate Barcode" to create a new barcode for this item<br />
                      • Use "Print" to print the barcode for labeling<br />
                      • Use "Download" to save the barcode image<br />
                      • Barcode will include item name, code, and price information
                    </Typography>
                  </Grid>
                  </> : ''
                }
            
            </Grid>
            </Grid>
            </Grid>
              {/* <Typography>some text goess here {JSON.stringify(stateOptions)}</Typography> */}
            </LocalizationProvider>
          </Box>
        {/* </CardContent> */}
        
        {/* Category Modal */}
        {categoryModalOpen && (
          <CategoryModal
            open={categoryModalOpen}
            onClose={handleCloseCategoryModal}
            onSuccess={refreshCategoriesData}
            editingCategory={editingCategory}
            editingSubCategory={editingSubCategory}
            selectedCategoryId={itemCategoryId}
            categories={itemCategoryOptions}
            isSubCategory={isSubCategoryModal}
          />
        )}
      </FormProvider>
  );
}

export default InventoryFormNew;